import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TisSupportService {

  constructor(private http: HttpClient) { }

  sendTISSupportForm(supportFormData) {
    return this.http.post(`user-info-public/contactTISSupport`, supportFormData, {withCredentials: true});
  }

}
